import { Component, OnInit, Input } from '@angular/core';
import { NavigationEnd, Router, Event as NavigationEvent  } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'modulo-whatsapp',
  templateUrl: './whatsapp.component.html',
  styleUrls: ['./whatsapp.component.scss']
})
export class WhatsappComponent implements OnInit {

  @Input("data") data:any       = null;
  @Input("template") template = null;
  @Input("page") page:any = null;
  public prefixo              = "web";
  public numero               = "";
  public text    = "Clique aqui e tire suas dúvidas via WhatsApp"; 

  constructor(
    private deviceService: DeviceDetectorService,
    private router: Router
  ){ 
    
  }
  open(){

    if(this.text !== "" && this.text !== null){
      window.open("https://"+this.prefixo+".whatsapp.com/send?phone="+this.numero+"&text="+this.text,"__blank");
    }else{
      window.open("https://"+this.prefixo+".whatsapp.com/send?phone="+this.numero,"__blank");
    }  
  }
  /**
   * 
   * Seta o número
   * 
   */
  setNumero(){
    
    let telefone = this.data.params.telefone.replace("(","").replace(")","").replace("-","").replace(" ","");

    this.numero = "55"+telefone;


  }
  /**
   * 
   * Seta a mensage
   * 
   */
  setMessage(){

    if(typeof(this.data.params.texto) != "undefined"){
      
      this.text = this.data.params.texto; 

    }

  }
  /**
   * 
   * On Data
   * 
   * 
   */
  onData(){

    const navEndEvents = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    );
    navEndEvents.subscribe((event: NavigationEnd) => {
      
    });

  }
  /**
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit(){
    this.onData();
    this.setNumero();
    this.setMessage();
    this.prefixo = this.deviceService.isDesktop() ? "web" : "api";
  }

}
